import React, { memo, useState } from 'react'
import styles from './PauseSolarProductDialog.module.scss'
import CommonDialog from '../../../../common/components/dialog/CommonDialog';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import solarProductService from '../../../../httpService/SolarProductService';
import { showLoader, hideLoader } from '../../../../stores/slices/loader-slice';
import { ExistingSolarProduct } from '../../../../model/solar-product/existing-solar-product';
import LoanProductOtpForm from '../otp-form/LoanProductOtpForm';

type Props = {
    product: ExistingSolarProduct
    onCloseDialog: () => void
    onProductPaused: () => void
}

const PauseSolarProductDialog: React.FC<Props> = memo((props: Props) => {
    const { product } = props

    const [dialogOpen, setDialogOpen] = useState(false);

    const dispatch = useDispatch();

    const pauseProduct = () => {
        dispatch(showLoader());
        solarProductService.adminPause(props.product.id)
        .then(() => {
            toast.success('OTP sent successfully');
            openDialog();
        }).catch(() => {
            toast.error('Failed to send OTP. Please try again.');
        }).finally(() => {
            dispatch(hideLoader());
        });
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    const toggleDialog = () => {
        setDialogOpen(!dialogOpen);
    }

    const openDialog = () => {
        setDialogOpen(true);
    }

    const resendOtp = async () => {
        solarProductService.adminPause(props.product.id).then(() => {
            toast.success('OTP sent successfully');
        }).catch(() => {
            toast.error('Failed to resend OTP. Please try again.');
        });
    }

    const verifyOtp = async (otp: string) => {
        dispatch(showLoader());
        solarProductService.adminPause(props.product.id, otp).then(() => {
            props.onProductPaused();
            props.onCloseDialog();
        }).catch(() => {
            toast.error('Invalid OTP. Please try again.');
        }).finally(() => {
            dispatch(hideLoader());
        });
    }

    return (
        <>
            <CommonDialog onCloseDialog={props.onCloseDialog}>
                <div className={styles.container}>
                    <div className={styles.title}>
                        Are you sure you want to {product.isPaused ? "unpause" : "pause"} this product?
                    </div>
                    <div className={styles.description}>
                    {product.isPaused ? "Unpausing" : "Pausing"} a product will make it {product.isPaused ? "available" : "unavailable"}  for purchase by customers.
                    </div>
                    <div className={styles.buttonContainer}>
                        <button className={`standardButton ${styles.button} ${styles.pauseButton}`} onClick={pauseProduct}>{product.isPaused ? "Unpause" : "Pause"}</button>
                        <button className={`standardButton ${styles.button}`} onClick={cancel}>Cancel</button>
                    </div>
                </div>
            </CommonDialog>
            {
                dialogOpen && <CommonDialog>
                    <LoanProductOtpForm
                        onResendOtp={resendOtp}
                        onVerifyOtp={verifyOtp}
                        onCloseDialog={toggleDialog}
                    />
                </CommonDialog>
            }
        </>
        
    )
})

export default PauseSolarProductDialog